import { useEffect, useState } from "react";

// 1024px, not the sitewide 768px tablet/desktop split (see TournamentsList.
// js's own isMobileWidth) - the docked side panel this drives (BottomSheetPanel)
// needs real width of its own (380px) alongside the tournament content next
// to it, which a 768-1023px tablet doesn't have to spare; those widths keep
// the mobile drag-up sheet instead. Reactive so rotating a tablet or resizing
// a desktop window across the breakpoint updates live instead of only on
// next full page load.
export const useIsWideViewport = (breakpoint = 1024) => {
    const [isWide, setIsWide] = useState(() => window.innerWidth >= breakpoint);
    useEffect(() => {
        const check = () => setIsWide(window.innerWidth >= breakpoint);
        window.addEventListener("resize", check);
        return () => window.removeEventListener("resize", check);
    }, [breakpoint]);
    return isWide;
};
